// The awaiting-payment page opens the Mollie checkout by script when the create-order wizard
// hands it a checkout URL. The wizard's form POST must not redirect to Mollie itself: the
// Content Security Policy's form-action refuses that redirect in Chromium and WebKit.
//
// The decision lives here, outside the React component, so that `node --test` covers it: the
// PHP suite proves the page receives the URL, this file proves the page acts on it. The file is
// .mjs so that `node --test` loads it as an ES module; Vite resolves the extension-less import.

// The URL the page must navigate to, or null when the page only follows the payment status:
// a plain visit, Mollie's return, a refresh, or a page that received no URL.
function checkoutUrlToOpen(pageData) {
    const checkoutUrl = pageData?.checkoutUrl;
    if (typeof checkoutUrl !== 'string' || checkoutUrl === '') {
        return null;
    }

    return checkoutUrl;
}

export { checkoutUrlToOpen };
